import React from 'react';

import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';

import { Box, GridLegacy as Grid, Stack, Typography } from '@mui/material';

import { AvailabilityDebugResponse, AvailabilityResponse, MergedRate } from '~/services/AccommodationService';

interface MergedRatesContentProps {
  availabilityDebugResponse: AvailabilityDebugResponse;
  mergedRate: MergedRate;
}

const getRateById = (availability: AvailabilityResponse, rateId: string, debug: AvailabilityDebugResponse['debug']) => {
  for (const property of Object.values(availability.properties)) {
    for (const room of Object.values(property.rooms)) {
      for (const rate of Object.values(room.ratesMap)) {
        if (rate.id === rateId) {
          return rate;
        }
      }
    }
  }
  for (const removedRate of debug.mergedRates) {
    if (removedRate.id === rateId) {
      return removedRate.rate;
    }
  }
  // throw new Error(`Rate with id ${rateId} not found`);
  return null;
};

export default function MergedRatesContent({ availabilityDebugResponse, mergedRate }: MergedRatesContentProps) {
  const winningRate = getRateById(
    availabilityDebugResponse.response,
    mergedRate.winningRateId,
    availabilityDebugResponse.debug,
  );
  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Typography>{mergedRate.description}</Typography>
        <Typography>Group: {mergedRate.groupId}</Typography>
      </Stack>

      <Grid container spacing={2}>
        {winningRate && (
          <Box height="70vh" fontSize="small" overflow="auto">
            <ReactDiffViewer
              oldValue={JSON.stringify(mergedRate.rate, null, 2)}
              newValue={JSON.stringify(winningRate, null, 2)}
              leftTitle="Rate that was merged"
              rightTitle="Rate that won"
              splitView
              extraLinesSurroundingDiff={5}
              compareMethod={DiffMethod.WORDS}
            />
          </Box>
        )}
        {!winningRate && (
          <Box height="70vh" fontSize="small" overflow="auto">
            <Typography>No rate found</Typography>
            <Typography>Rate ID: {mergedRate.winningRateId}</Typography>
            <Typography>Rate Group: {mergedRate.groupId}</Typography>
            <Typography>Rate Description: {mergedRate.description}</Typography>
          </Box>
        )}
      </Grid>
    </Stack>
  );
}
